import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import { setPageIndexing } from '@/utils/seo'
import portalRoutes from './portal'
import adminRoutes from './admin'

const router = createRouter({
  history: createWebHistory(),
  routes: [...portalRoutes, ...adminRoutes],
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const isAdminRoute = to.path.startsWith('/admin')
  const isLoginPage = to.path === '/admin/login'
  const hasToken = !!getToken()

  if (isAdminRoute && !isLoginPage && to.meta.requiresAuth !== false) {
    if (!hasToken) {
      next({ path: '/admin/login', query: { redirect: to.fullPath } })
      return
    }
  }

  if (isLoginPage && hasToken) {
    next({ path: '/admin/dashboard' })
    return
  }

  next()
})

router.afterEach((to) => {
  const indexable = !to.matched.some((route) => route.meta.noindex)
  setPageIndexing(indexable)
})

export default router
